import { axiosInstance } from "../../../../../Services";

export const fetchAdmins = async (showDownline = 0) => {
    try {
      const res = await axiosInstance.get(
        `/internal/user/admins?showDownline=${showDownline}`
      );
      return res;
    } catch (error) {
      throw error;
    }
  };
  
  export const updateCardAssignee = async (cardId, assignedTo) => {
    try {
      const res = await axiosInstance.put(
        `/mmhboard/cards/${cardId}`,
        {
          assigned_to: assignedTo,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return res;
    } catch (error) {
      throw error;
    }
  };
  